import { render, staticRenderFns } from "./SchemaInputModal.vue?vue&type=template&id=402f3a36&scoped=true&"
import script from "./SchemaInputModal.vue?vue&type=script&lang=js&"
export * from "./SchemaInputModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402f3a36",
  null
  
)

export default component.exports